import { render, staticRenderFns } from "./BookGenerator.vue?vue&type=template&id=763c961f&scoped=true&"
import script from "./BookGenerator.vue?vue&type=script&lang=js&"
export * from "./BookGenerator.vue?vue&type=script&lang=js&"
import style0 from "./BookGenerator.vue?vue&type=style&index=0&id=763c961f&prod&scoped=true&lang=css&"
import style1 from "./BookGenerator.vue?vue&type=style&index=1&id=763c961f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763c961f",
  null
  
)

export default component.exports